import { useLazyLoadedImage } from "@nova/toolkit-pure-hooks"
import { selectFireById } from "features/entity-caching/fires/selectors"
import { useAppSelector } from "integrations/redux/hooks"
import { useCallback } from "react"

const defaultThumbnailUrl = "/images/project-card-default.png"

const fetchImageBlob = async (url: string) => {
    const res = await fetch(url)
    if (!res.ok) throw new Error(`Failed to fetch image at ${url}: ${res.status}`)
    return res.blob()
}

export const useLazyLoadedProjectThumbnail = ({ projectId }: { projectId: string }) => {
    const project = useAppSelector(selectFireById(projectId))
    const thumbnailUrl = project?.thumbnailUrl
    const fetchBlob = useCallback(async () => {
        const url = thumbnailUrl || defaultThumbnailUrl
        try {
            return await fetchImageBlob(url)
        } catch (err) {
            if (url === defaultThumbnailUrl) throw err
            return fetchImageBlob(defaultThumbnailUrl)
        }
    }, [thumbnailUrl])
    return useLazyLoadedImage({
        type: "ProjectThumbnail",
        imageKey: project?.id ?? "unknown",
        fetchBlob,
    })
}
